export const toComma = (value: string | number): string => {
  return value.toString().replace('.', ',');
};

export const toDot = (value: string | number): string => {
  return value.toString().replace(',', '.');
};
